import React from "react"
import { graphql, useLazyLoadQuery } from "react-relay"

import { ResourceSeatReminderQuery } from "~/common/__generated__/ResourceSeatReminderQuery.graphql"

import { accountBillingUrl } from "~/helpers/routes"

import { usePermissions } from "~/Permissions/usePermissions"

type Action = "archive" | "delete" | "both"

type Props = {
  action: Action
}

const ResourceSeatReminder: React.FC<Props> = ({ action }) => {
  const data = useLazyLoadQuery<ResourceSeatReminderQuery>(
    graphql`
      query ResourceSeatReminderQuery {
        billing(syncSubscription: false) {
          subscription {
            billingPeriodUnit
          }
        }
        current_user {
          id
          account {
            id
            billing_type
          }
        }
      }
    `,
    {},
  )

  const { can, subject } = usePermissions()
  const isAdmin = can("manage", subject("Account"))

  const actionText = {
    archive: "archiving",
    delete: "deleting",
    both: "archiving or deleting",
  }[action]

  if (
    data.billing?.subscription?.billingPeriodUnit !== "month" ||
    data.current_user?.account?.billing_type !== "SEAT"
  ) {
    return null
  }

  return (
    <p style={{ color: "var(--slate)", marginTop: 15 }}>
      To keep billing costs optimized,{" "}
      {isAdmin ? (
        <>
          remember to{" "}
          <a
            href={accountBillingUrl()}
            target="_blank"
            rel="noopener noreferrer"
          >
            adjust resource seats
          </a>
        </>
      ) : (
        "please ask your account admin to adjust resource seats"
      )}{" "}
      after {actionText} a resource.
    </p>
  )
}

export default ResourceSeatReminder
